/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisabledIntegrationsResponse } from './DisabledIntegrationsResponse';
import {
    DisabledIntegrationsResponseFromJSON,
    DisabledIntegrationsResponseFromJSONTyped,
    DisabledIntegrationsResponseToJSON,
    DisabledIntegrationsResponseToJSONTyped,
} from './DisabledIntegrationsResponse';

/**
 * 
 * @export
 * @interface FindAllDisabledIntegrations200Response
 */
export interface FindAllDisabledIntegrations200Response {
    /**
     * 
     */
    data?: DisabledIntegrationsResponse;
}

/**
 * Check if a given object implements the FindAllDisabledIntegrations200Response interface.
 */
export function instanceOfFindAllDisabledIntegrations200Response(value: object): value is FindAllDisabledIntegrations200Response {
    return true;
}

export function FindAllDisabledIntegrations200ResponseFromJSON(json: any): FindAllDisabledIntegrations200Response {
    return FindAllDisabledIntegrations200ResponseFromJSONTyped(json, false);
}

export function FindAllDisabledIntegrations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllDisabledIntegrations200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DisabledIntegrationsResponseFromJSON(json['data']),
    };
}

export function FindAllDisabledIntegrations200ResponseToJSON(json: any): FindAllDisabledIntegrations200Response {
    return FindAllDisabledIntegrations200ResponseToJSONTyped(json, false);
}

export function FindAllDisabledIntegrations200ResponseToJSONTyped(value?: FindAllDisabledIntegrations200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DisabledIntegrationsResponseToJSON(value['data']),
    };
}

